export default __webpack_public_path__ + "assets/8842cc0f936e8c880ea6b9f1297b8b27.png";